import React from 'react';
import { Clock3Icon, FrownIcon, SearchIcon, ShoppingBagIcon, WrenchIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const painPoints = [{
  icon: Clock3Icon,
  text: 'Domingo a la noche preparando actividades.'
}, {
  icon: SearchIcon,
  text: 'Horas buscando ideas en Pinterest.'
}, {
  icon: ShoppingBagIcon,
  text: 'Comprando planificaciones una por una.'
}, {
  icon: WrenchIcon,
  text: 'Adaptando recursos que nunca terminan de convencerte.'
}, {
  icon: FrownIcon,
  text: 'Llegando al lunes ya cansada.'
}];
export function ProblemSection() {
  return <section className="bg-slate-900 py-10 text-white sm:py-14 md:py-16" data-id="element-122">
      <div className="container mx-auto px-4 md:px-6" data-id="element-123">
        <div className="mx-auto max-w-4xl" data-id="element-124">
          <div className="text-center" data-id="element-125">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-yellow-300" data-id="element-126">
              Si tu semana empieza antes de empezar
            </p>
            <h2 className="mt-2 text-3xl font-black tracking-tight sm:text-4xl" data-id="element-127">
              ¿Te pasa esto cada semana?
            </h2>
            <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-128">
              No es que te falte vocación. Estás cansada de llevarte la
              planificación a casa y sentir que nunca terminás.
            </p>
          </div>

          <div className="mt-6 grid gap-2.5 sm:grid-cols-2 sm:gap-3" data-id="element-129">
            {painPoints.map(({
            icon: Icon,
            text
          }, index) => <motion.div key={text} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-center gap-3 rounded-2xl border border-slate-700 bg-slate-800 p-3.5" data-id="element-130">
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-pink-500/15 text-pink-300" data-id="element-131">
                  <Icon className="h-4.5 w-4.5" data-id="element-132" />
                </span>
                <p className="text-sm font-semibold leading-snug text-slate-100" data-id="element-133">
                  {text}
                </p>
              </motion.div>)}
          </div>

          <div className="mt-6 rounded-2xl border border-yellow-300/40 bg-yellow-300 px-5 py-5 text-center text-slate-900 shadow-lg" data-id="element-134">
            <p className="text-xl font-black sm:text-2xl" data-id="element-135">
              No necesitás trabajar más horas.
            </p>
            <p className="mt-1 text-lg font-bold" data-id="element-136">Necesitás un sistema.</p>
          </div>
        </div>
      </div>
    </section>;
}